/**
 * 页面ID
 */
export const PAGE_ID = {
  copilot: 'bugly-copilot',
  resourceManage: 'resource-manage',
  productResource: 'product-resource',
  buyResourcePack: 'buy-resource-pack',
  resourcePackPayOrder: 'resource-pack-pay-order',
  orderManage: 'order-manage',
  payResult: 'pay-result',
  topMenu: 'top-menu',
  cpu: {
    analytics: 'cpu-analytics',
    list: 'cpu-list',
    drillDown: 'cpu-drill-down',
    detail: 'cpu-detail',
  },
  customDashboard: {
    mine: 'customDashboard-mine',
    public: 'customDashboard-public',
  },
  track: 'track',
  pageDuration: 'page-duration',
  webConfigManager: 'web-config-manager',
  abnormalExitInfo: 'abnormal-exit-info',
  applicationExitInfo: 'application-exit-info',
  miniprogram: {
    static: 'miniprogram-static',
    api: 'miniprogram-api',
    error: 'miniprogram-error',
    log: 'miniprogram-log',
    perf: 'miniprogram-perf',
    launch: 'miniprogram-launch',
    runtime: 'miniprogram-runtime',
    pv: 'miniprogram-pv',
    event: 'miniprogram-event',
    custom: 'miniprogram-custom',
  },
  electron: {
    static: 'electron-static',
    api: 'electron-api',
    error: 'electron-error',
    blankScreen: 'blank-screen',
    session: 'electron-session',
    log: 'electron-log',
    perf: 'electron-perf',
    load: 'electron-load',
    launch: 'electron-launch',
    runtime: 'electron-runtime',
    pv: 'electron-pv',
    event: 'electron-event',
    custom: 'electron-custom',
    browser: 'electron-browser',
    crashList: 'electron-crash-list',
    crashDetail: 'electron-crash-detail',
  },
  web: {
    static: 'web-static',
    api: 'web-api',
    error: 'web-error',
    errorCallerDetail: 'web-error-caller-detail',
    errorDetail: 'web-error-detail',
    errorList: 'web-error-list',
    blankScreen: 'web-blank-screen',
    session: 'web-session',
    log: 'web-log',
    perf: 'web-perf',
    load: 'web-load',
    launch: 'web-launch',
    runtime: 'web-runtime',
    pv: 'web-pv',
    event: 'web-event',
    custom: 'web-custom',
    browser: 'web-browser',
  },
  kuikly: {
    detail: 'kuikly-detail',
    static: 'kuikly-static',
    api: 'kuikly-api',
    error: 'kuikly-error',
    log: 'kuikly-log',
    perf: 'kuikly-perf',
    pv: 'kuikly-pv',
    event: 'kuikly-event',
    custom: 'kuikly-custom',
  },
  hippy: {
    static: 'hippy-static',
    api: 'hippy-api',
    error: 'hippy-error',
    log: 'hippy-log',
    perf: 'hippy-perf',
    pv: 'hippy-pv',
    event: 'hippy-event',
    custom: 'hippy-custom',
  },
  battery: {
    analytics: 'battery-analytics',
    factor: 'battery-factor',
    detail: 'battery-detail',
    list: 'battery-list',
  },
  diagnose: {
    commandDelivery: {
      list: 'diagnose-command-delivery-list',
      detail: 'diagnose-command-delivery-detail',
      tags: 'diagnose-command-delivery-tags',
    },
    colouration: {
      list: 'diagnose-colouration-list',
      detail: 'diagnose-colouration-detail',
    },
    logDecode: 'diagnose-log-decode',
    account: {
      list: 'diagnose-account-list',
    },
  },
  gpt: 'gpt',
  aiMonitor: 'ai-monitor',
  indexMain: 'index-main',
  overview: 'overview',
  overviewQualityReport: 'overview-quality-report',
  login: 'login',
  register: 'register',
  selectAccount: 'select-account',
  network: {
    list: 'network-list',
    detail: 'network-detail',
  },
  networkError: {
    list: 'network-error-list',
    detail: 'network-error-detail',
  },
  dropFrame: {
    analytics: 'dropframe-analytics',
    list: 'dropframe-issues-list',
    detail: 'dropframe-issues-detail',
    tree: 'dropframe-tree',
    taskDetail: 'dropframe-tree-offline-task-detail',
  },
  net: {
    list: 'net-list',
    detail: 'net-detail',
    analytics: 'net-analytics',
    case: 'net-case-case',
    task: {
      list: 'net-task-list',
      detail: 'net-task-detail',
    },
  },
  power: {
    anomalyAnalysis: {
      list: 'power-list',
      detail: 'power-detail',
      analytics: 'power-analytics',
    },
  },
  crash: {
    list: 'crash-list',
    detail: 'crash-detail',
    dashboard: 'crash-dashboard',
    ft: 'crash-ft',
    keyword: 'crash-keyword',
    applicationExitInfo: 'application-exit-info',
    caller: 'crash-caller',
    relatedMonitoring: 'related-monitoring',
    diagnoseDetail: 'crash-diagnose-detail',
  },
  error: {
    list: 'error-list',
    detail: 'error-detail',
    dashboard: 'error-dashboard',
    ft: 'error-ft',
    caller: 'error-caller',
  },
  anr: {
    analytics: 'anr-analytics',
    list: 'anr-list',
    detail: 'anr-detail',
    dashboard: 'anr-dashboard',
    dropFrameList: 'anr-drop-frame-list',
    ft: 'anr-ft',
    // anr安卓 数据源为bugly
    android: {
      list: 'anr-android-list',
      detail: 'anr-android-detail',
      caller: 'anr-android-caller',
    },
  },
  foom: {
    analytics: 'foom-analytics',
    issues: {
      list: 'foom-issues-list',
      detail: 'foom-issues-detail',
    },
    malloc: {
      list: 'foom-malloc-list',
      detail: 'foom-malloc-detail',
    },
    // foom安卓 数据源为bugly
    android: {
      list: 'foom-android-list',
      detail: 'foom-android-detail',
    },
  },
  launch: {
    analytics: 'launch-analytics',
    issues: 'launch-issues',
  },
  memory: {
    detail: {
      list: 'memory-detail-list',
      detail: 'memory-detail-detail',
    },
    analytics: 'memory-analytics',
    javaLeak: {
      list: 'memory-javaleak-list',
      detail: 'memory-javaleak-detail',
    },
    bigPic: {
      list: 'memory-bigpic-list',
      detail: 'memory-bigpic-detail',
    },
    vcLeak: {
      list: 'memory-vc-list',
      detail: 'memory-vc-detail',
    },
    badMalloc: {
      list: 'memory-badmalloc-list',
      detail: 'memory-badmalloc-detail',
    },
    fd: {
      list: 'memory-fd-list',
      detail: 'memory-fd-detail',
    },
    memGraph: {
      list: 'memory-memgraph-list',
      detail: 'memory-memgraph-detail',
    },
    vmmap: {
      detail: 'memory-vmmap-detail',
    },
    native: {
      list: 'memory-native-list',
      detail: 'memory-native-detail',
    },
    high: {
      list: 'memory-high-list',
      detail: 'memory-high-detail',
      analytics: 'memory-high-analytics',
    },
  },
  compliance: {
    homepage: 'compliance-homepage',
    analytics: 'compliance-analytics',
    report: 'compliance-report',
    agreement: 'compliance-agreement',
    privacyFlare: 'compliance-privacy-flare',
    issues: {
      list: 'compliance-issues-list',
      detail: 'compliance-issues-detail',
    },
    functions: {
      list: 'compliance-functions-list',
      detail: 'compliance-functions-detail',
    },
    config: {
      list: 'compliance-config-list',
    },
    download: {
      list: 'compliance-download-list',
      detail: 'compliance-download-detail',
    },
    selfLaunch: {
      list: 'compliance-selflaunch-list',
      detail: 'compliance-selflaunch-detail',
    },
    network: {
      list: 'compliance-network-list',
      detail: 'compliance-network-detail',
    },
    modules: {
      list: 'compliance-modules-list',
      detail: 'compliance-modules-detail',
    },
    fileAccess: {
      list: 'compliance-file-access-list',
      detail: 'compliance-file-access-detail',
    },
  },
  metricKit: {
    log: 'metrickit-log',
    crashDiagnostics: 'metrickit-crash-diagnostics',
  },
  setting: {
    weightSetting: 'weight-setting',
    productInfo: 'product-info',
    productMember: 'product-member',
    alertTask: 'alerk-task',
    appDeliverConfig: 'app-delivery-config',
    complianceConfig: 'compliance-config',
    tapdSetting: 'tapd-setting',
    tagManage: 'tag-manage',
    symbolManage: 'symbol-manage',
    keywordSetting: 'keyword-setting',
    dimensionManage: 'dimension-manage',
    notification: 'notification',
    version: 'version',
    ftManage: 'ft-manage',
    ClusteringConfig: 'clustering-config',
    ProductConfig: 'product-config',
  },
  shiply: {
    homepage: 'shiply-homepage',
  },
};
